module.exports = __webpack_public_path__ + "static/media/10.09f08809.png";